module.exports = __webpack_public_path__ + "static/img/gingerprinting.fd00336.gif";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/fingerprint/gingerprinting.gif
// module id = VvSU
// module chunks = 15